
import { i18nText } from '@/locales';

import {Component, Prop, Vue} from "vue-property-decorator";
import StaffUpdateForm from "../../../../form/staff/StaffUpdate";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import moment from 'moment';
import {date} from "@/utils/validators";

@Component({
  components: {FormGroup},
  methods: {moment}
})
export default class StaffUpdateFormComponent extends Vue {
  @Prop() form!: StaffUpdateForm;

  handleBirthDateChange(value: any): void {
    if (value != null && value != '') {
      this.form.clearErrors('birth_date');
      this.form.birth_date = value.format('DD.MM.YYYY');
    } else {
      this.form.setErrors('birth_date', i18nText("Введите корректную дату"));
    }
  }

  handleEmploymentDateChange(value: any): void {
    if (value != null && value != '') {
      this.form.clearErrors('employment_date');
      this.form.employment_date = value.format('DD.MM.YYYY');
    } else {
      this.form.setErrors('employment_date', i18nText("Введите корректную дату"));
    }
  }
}
